import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "11",
  cy: "11",
  r: "6.75",
  stroke: "currentColor",
  "stroke-width": "2.5"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.7626 21.2374C19.2508 21.7256 20.0422 21.7256 20.5304 21.2374C21.0185 20.7492 21.0185 19.9578 20.5304 19.4696L18.7626 21.2374ZM17.5304 16.4696L16.6465 15.5857L14.8787 17.3535L15.7626 18.2374L17.5304 16.4696ZM20.5304 19.4696L17.5304 16.4696L15.7626 18.2374L18.7626 21.2374L20.5304 19.4696Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = ["width", "height"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "11",
  cy: "11",
  r: "7.25",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.1162 20.8838C19.409 21.1767 19.8839 21.1767 20.1768 20.8838C20.4697 20.591 20.4697 20.1161 20.1768 19.8232L19.1162 20.8838ZM17.1768 16.8232L16.6465 16.2929L15.5858 17.3535L16.1162 17.8838L17.1768 16.8232ZM20.1768 19.8232L17.1768 16.8232L16.1162 17.8838L19.1162 20.8838L20.1768 19.8232Z",
  fill: "currentColor"
}, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchIcon',
  props: {
  width: {
    type: Number,
    default: 26
  },
  height: {
    type: Number,
    default: 26
  },
  wrapperClass: {
    type: String,
    default: ""
  },
  checked: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.checked)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        width: __props.width,
        height: __props.height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        class: _normalizeClass(__props.wrapperClass)
      }, [
        _hoisted_2,
        _createTextVNode(),
        _hoisted_3,
        _createTextVNode(),
        _hoisted_4
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("svg", {
        key: 1,
        width: __props.width,
        height: __props.height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        class: _normalizeClass(__props.wrapperClass)
      }, [
        _hoisted_6,
        _createTextVNode(),
        _hoisted_7,
        _createTextVNode(),
        _hoisted_8
      ], 10, _hoisted_5))
}
}

})